import { DocTypeEnum } from '@common/constants/enums/docType';
import { getNameFromDNI, getNameFromPlatformPlayer } from './helpers';

export const createBISResponseModel = (data = null, success = true, errors = []) => (
  success
    ? { success, data }
    : { success, errorMessage: errors.map((item) => item.message).join(', ') }
);

export const createBISUserModel = (form = {}, verificationOptions = {}) => ({
  id: form.identifier,
  identifier: form.identifier,
  name: getNameFromDNI(form.type, form.identifier, verificationOptions),
  typeDocument: verificationOptions.docTypes?.find((item) => DocTypeEnum[item.type] === form.type)?.name || '',
});

export const createPlatformUserModel = (player, verificationOptions = {}) => {
  const { DocNumber, FirstName, LastName } = player;
  const type = 1;
  return {
    id: DocNumber,
    identifier: DocNumber,
    name: getNameFromPlatformPlayer(FirstName, LastName),
    documentNumber: getNameFromDNI(type, DocNumber, verificationOptions),
  };
};
